import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TextField, useMediaQuery } from "@mui/material";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { auth, db } from "../helper/firebaseClient";
import { doc, setDoc } from "firebase/firestore";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Checkbox } from "@mui/joy";
import { GitHub } from "@mui/icons-material";

// images from public folder
const logo = `${process.env.PUBLIC_URL}/assets/auth/logo.webp`;
const logoBlack = `${process.env.PUBLIC_URL}/assets/auth/logo-black.webp`;

const SignUp = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [fullName, setFullName] = useState("");
  const [organization, setOrganization] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [organizationData, setOrganizationData] = useState([]);
  const [pageErr, setPageErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const isSamePassword = (password, confirmPassword) => {
    if (password === confirmPassword) {
      return true;
    } else {
      return false;
    }
  };

  const isStrongPassword = (password) => {
    //  Use 8 or more characters with a mix of letters, numbers &symbols
    const regex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;
    return regex.test(password);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);

    if (!isSamePassword(password, confirmPassword)) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }
    if (!isStrongPassword(password)) {
      setError("Password is not strong enough");
      setLoading(false);
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      await sendEmailVerification(user);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/auth/sign-up/`,
        {
          fullName,
          email,
          password,
          organization,
          uid: user.uid,
        }
      );

      try {
        await setDoc(doc(db, "userChats", user.uid), {});
      } catch (error) {
        console.error("Error writing document: ", error);
      }

      const { message } = response.data;

      setMessage(message);
      setLoading(false);
    } catch (err) {
      setError(
        err.errors ? err.errors[0].message : err.error || "An error occurred"
      );
      setLoading(false);
    }
  }

  useEffect(() => {
    const orgData = async () => {
      try {
        const org = await axios.get(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/org/list_orgs`
        );
        console.log(org.data);
        setOrganizationData(org.data);
      } catch (error) {
        const errMsg = error.message + "Please try again later.";
        console.log(error.message);
        setPageErr(errMsg);
      }
    };

    orgData();
  }, []);
  /**
   * comment this out on dev mode
   * as the api call fails from localhost
   */
  // if (pageErr) {
  //   return <ErrorPage error={pageErr} />;
  // }

  return (
    <>
      <div className="w-full min-h-screen  h-full overflow-clip font-raleway relative ">
        <Topbar />
        <div className="w-screen  h-full  top-0 left-0 right-0 overflow-x-clip  -z-20 absolute">
          <img
            className="w-screen h-full object-cover "
            src={
              "https://firebasestorage.googleapis.com/v0/b/twokey-a14ec.appspot.com/o/backdrop.svg?alt=media&token=b608f0cb-f474-4b8d-ba73-2be49ffaabfa"
            }
            alt="twokeySignupImage"
          />
        </div>
        <div className="w-screen bg-gradient-to-b from-black  to-transparent h-[20vh] top-0 left-0 right-0 overflow-x-clip overflow-y-clip -z-10 opacity-70 absolute"></div>
        <div className="w-screen min-h-screen backdrop-blur-[2px] top-0 left-0 right-0 overflow-x-clip overflow-y-clip -z-10 opacity-70 absolute"></div>
        <div className="flex  justify-center items-center w-full h-fit scroll-auto">
          <div className="bg-white  w-full md:w-fit   md:max-w-[60%] lg:max-w-[50%] my-24 m-2    p-8 rounded-2xl space-y-6 ">
            <img src={logoBlack} alt="logo" className="mr-auto" />
            <div className="space-y-1">
              <h1 className="mt-8 font-semibold ">Get Started Now</h1>
              <p>Sign up for free to access to in any of our products</p>
            </div>

            <form onSubmit={handleSubmit} className="p-4 text-center w-full">
              <span className="my-4 flex flex-col justify-center space-y-4">
                <label className="text-md text-left " id="organization">
                  Organization
                </label>
                <Select
                  className="select-custom"
                  id="organization"
                  value={organization}
                  label="organizations"
                  name="organization"
                  onChange={(e) => setOrganization(e.target.value)}
                  size="small"
                >
                  {organizationData.length &&
                    organizationData.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>

                <div className="w-full  text-left">
                  <div className="w-full space-y-2 text-left">
                    <label
                      className="font-semibold text-md text-left "
                      id="lastName"
                    >
                      Full Name
                    </label>

                    <input
                      type="text"
                      id="fullName"
                      className="flex w-full rounded-xl border border-zinc-400 hover:border-zinc-900 outline-blue-500  duration-200 bg-background px-3 py-2"
                      placeholder="John Doe"
                      name="fullName"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="w-full text-left">
                  <label
                    className="font-semibold text-md text-left "
                    id="email"
                  >
                    Email
                  </label>
                  <span id="email" className="flex flex-row gap-2">
                    <input
                      type="email"
                      className="flex  w-full rounded-xl border outline-blue-500 border-zinc-400 hover:border-zinc-900 duration-200 bg-background px-3 py-2  "
                      placeholder="john@doe.com"
                      name="email"
                      onChange={(e) => setEmail(e.target.value)}
                      size="small"
                    />
                  </span>
                </div>
                <div className="space-y-2 flex flex-col justify-start items-center w-full">
                  <div className="lg:flex justify-between items-center w-full gap-2">
                    <div className="w-full space-y-2 text-left">
                      <label
                        className="font-semibold text-md text-left "
                        id="Password"
                      >
                        Password
                      </label>

                      <input
                        id="password"
                        placeholder="Enter your Password"
                        className="flex  w-full rounded-xl border outline-blue-500 border-zinc-400 hover:border-zinc-900 duration-200 bg-background px-3 py-2  "
                        name="password"
                        type={showPassword ? "text" : "password"}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="w-full space-y-2 text-left">
                      <label
                        className="text-md text-left  font-semibold"
                        id="confirm-password"
                      >
                        Confirm password
                      </label>

                      <input
                        id="confirm-password"
                        placeholder="Enter your password again"
                        className="flex  w-full rounded-xl border outline-blue-500 border-zinc-400 hover:border-zinc-900 duration-200 bg-background px-3 py-2  "
                        name="confirm-password"
                        type={showPassword ? "text" : "password"}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                  </div>
                  {password && !isStrongPassword(password) && (
                    <p className="text-left w-full text-red-500">
                      Password is not strong enough
                    </p>
                  )}{" "}
                  {isStrongPassword(password) && (
                    <p className="text-left text-green-500 w-full">
                      Password is strong enough
                    </p>
                  )}
                  {password &&
                    confirmPassword &&
                    !isSamePassword(password, confirmPassword) && (
                      <p className="text-left w-full text-red-500">
                        Passwords do not match
                      </p>
                    )}
                  <p className="text-left w-full">
                    Use 8 or more characters with a mix of letters, numbers &
                    symbols
                  </p>
                  <span className="w-fit flex justify-start items-center gap-2 mr-auto">
                    <Checkbox
                      color="neutral"
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)}
                    />
                    Show password
                  </span>
                </div>
              </span>

              {loading ? (
                <CircularProgress
                  style={{ color: "#000", height: 25, width: 25 }}
                />
              ) : (
                <button
                  type="submit"
                  // className="bg-blue-600 text-white py-1 px-10 text-center mt-8 rounded-sm"
                  className="w-full py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-800 border border-zinc-700 font-semibold"
                >
                  Sign Up
                </button>
              )}
              {error && <p className="text-red-500 text-center">{error}</p>}
              {message && (
                <p className="text-indigo-500 text-center">{message}</p>
              )}

              <p className="text-gray-500 mt-4 text-left">
                Already have an account?{" "}
                <Link to="/login" className="text-indigo-600 font-semibold">
                  Sign in
                </Link>
              </p>
            </form>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default SignUp;

function Topbar() {
  return (
    <div className="grid grid-cols-2 w-full h-16 px-4 md:px-16 py-2 bg-transparent  z-50 font-inter">
      <div className="flex items-center">
        <img src={logo} alt="logo" className="" />
      </div>
      <div className="flex items-center justify-end gap-8 ">
        <Link
          to="/about"
          className="hidden lg:inline-flex text-white  hover:text-zinc-300 duration-200"
        >
          About
        </Link>
        <Link
          to="/product"
          className="text-white  hidden lg:inline-flex hover:text-zinc-300 duration-200"
        >
          Product
        </Link>
        <Link
          to="/contact"
          className="text-white hidden lg:inline-flex  hover:text-zinc-300 duration-200"
        >
          Contact
        </Link>
        <Link
          to="/login"
          className="text-white hover:border-white border border-transparent hover:bg-blue-500/5 px-6 py-2 rounded-xl hover:text-zinc-300 duration-200 "
        >
          LogIn
        </Link>

        <Link
          to="/signup"
          className="bg-white hidden lg:flex rounded-xl px-6 py-2 hover:bg-white/90 duration-200 hover:text-blue-600  justify-start items-center gap-2 "
        >
          <span>Register</span>
          <span>
            <ArrowRightAltIcon color="white" fill="white" />
          </span>
        </Link>
      </div>
    </div>
  );
}

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-800 py-8">
      <div className=" px-4  md:px-16">
        <div className="md:grid md:grid-cols-5 gap-8">
          <div className="w-full space-y-4 col-span-2 lg:max-w-[70%]">
            <img src={logoBlack} alt="Logo" />
            <p className="text-sm"></p>
            <div className="flex space-x-4 mt-4">
              {/* Social Media Icons */}
              <a href="#" className="text-gray-600 hover:text-gray-900">
                <GitHubIcon />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                <DiscordIcon />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                <TwitterIcon />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                <LinkedInIcon />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:flex justify-start items-center col-span-3 w-full space-y-6 mt-8 lg:mt-0 md:space-y-0">
            <div className="w-full ">
              <h3 className="text-lg font-semibold mb-2">Product</h3>
              <ul>
                <li className="mb-1">
                  <a href="#" className="hover:underline">
                    Product
                  </a>
                </li>
                <li className="mb-1">
                  <a href="#" className="hover:underline">
                    Pricing
                  </a>
                </li>
              </ul>
            </div>
            <div className="w-full ">
              <h3 className="text-lg font-semibold mb-2">Resources</h3>
              <ul>
                <li className="mb-1">
                  <a href="#" className="hover:underline">
                    Docs
                  </a>
                </li>
              </ul>
            </div>
            <div className="w-full">
              <h3 className="text-lg font-semibold mb-2">Company</h3>
              <ul>
                <li className="mb-1">
                  <a href="#" className="hover:underline">
                    Home
                  </a>
                </li>
                <li className="mb-1">
                  <a href="#" className="hover:underline">
                    About
                  </a>
                </li>
                <li className="mb-1">
                  <a href="#" className="hover:underline">
                    Contact and Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className=" pt-4 mt-8 text-sm  font-mono">
          © 2024 COPYRIGHT TWO KEY PVT LTD'S.
        </div>
      </div>
    </footer>
  );
};

const GitHubIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49998 0.546875C7.40567 0.546875 6.32204 0.762425 5.31099 1.18122C4.29995 1.60001 3.38129 2.21384 2.60747 2.98765C1.04466 4.55046 0.166687 6.67007 0.166687 8.88021C0.166687 12.5635 2.55836 15.6885 5.86669 16.7968C6.28336 16.8635 6.41669 16.6052 6.41669 16.3802V14.9718C4.10836 15.4718 3.61669 13.8552 3.61669 13.8552C3.23336 12.8885 2.69169 12.6302 2.69169 12.6302C1.93336 12.1135 2.75002 12.1302 2.75002 12.1302C3.58336 12.1885 4.02502 12.9885 4.02502 12.9885C4.75002 14.2552 5.97502 13.8802 6.45002 13.6802C6.52502 13.1385 6.74169 12.7718 6.97502 12.5635C5.12502 12.3552 3.18336 11.6385 3.18336 8.46354C3.18336 7.53854 3.50002 6.79687 4.04169 6.20521C3.95836 5.99687 3.66669 5.13021 4.12502 4.00521C4.12502 4.00521 4.82502 3.78022 6.41669 4.85522C7.07502 4.67188 7.79169 4.58021 8.49998 4.58021C9.20838 4.58021 9.92498 4.67188 10.5834 4.85522C12.175 3.78022 12.875 4.00521 12.875 4.00521C13.3334 5.13021 13.0417 5.99687 12.9584 6.20521C13.5 6.79687 13.8167 7.53854 13.8167 8.46354C13.8167 11.6468 11.8667 12.3468 10.0084 12.5552C10.3084 12.8135 10.5834 13.3218 10.5834 14.0968V16.3802C10.5834 16.6052 10.7167 16.8718 11.1417 16.7968C14.45 15.6802 16.8334 12.5635 16.8334 8.88021C16.8334 7.78586 16.6178 6.70222 16.199 5.69118C15.7803 4.68013 15.1664 3.76147 14.3926 2.98765C13.6188 2.21384 12.7001 1.60001 11.6891 1.18122C10.678 0.762425 9.59438 0.546875 8.49998 0.546875Z"
        fill="#181C1F"
      />
    </svg>
  );
};

export const DiscordIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4336_69911)">
        <path
          d="M17.4307 5.12303C16.1557 4.54803 14.789 4.12303 13.3599 3.88136C13.3471 3.87892 13.334 3.88049 13.3222 3.88587C13.3104 3.89124 13.3006 3.90015 13.294 3.91136C13.119 4.21886 12.924 4.61969 12.7874 4.93636C11.2716 4.70989 9.73064 4.70989 8.21489 4.93636C8.06267 4.58541 7.89102 4.24322 7.70073 3.91136C7.69428 3.90001 7.68452 3.8909 7.67276 3.88525C7.66099 3.87959 7.64779 3.87765 7.63489 3.8797C6.20656 4.12136 4.8399 4.54636 3.56407 5.12219C3.55309 5.1268 3.54379 5.13465 3.5374 5.14469C0.944078 8.95718 0.233246 12.6756 0.582412 16.3472C0.583384 16.3562 0.586175 16.3649 0.590616 16.3728C0.595057 16.3807 0.601055 16.3876 0.608245 16.393C2.1219 17.4951 3.81018 18.3346 5.6024 18.8764C5.61489 18.8802 5.62826 18.8802 5.64074 18.8763C5.65323 18.8725 5.66426 18.8649 5.6724 18.8547C6.0574 18.338 6.40073 17.7922 6.69406 17.2189C6.71156 17.1855 6.6949 17.1455 6.6599 17.1322C6.12157 16.9295 5.59997 16.6848 5.0999 16.4005C5.09091 16.3954 5.08334 16.3881 5.07786 16.3794C5.07239 16.3706 5.06917 16.3605 5.06851 16.3503C5.06785 16.3399 5.06976 16.3296 5.07408 16.3202C5.07839 16.3108 5.08498 16.3026 5.09323 16.2964C5.19823 16.2189 5.30323 16.138 5.40323 16.0572C5.41223 16.0499 5.42308 16.0453 5.43455 16.0438C5.44603 16.0424 5.45769 16.0441 5.46823 16.0489C8.74072 17.5189 12.2849 17.5189 15.519 16.0489C15.5296 16.0437 15.5414 16.0419 15.553 16.0431C15.5647 16.0444 15.5757 16.0491 15.5849 16.0564C15.6849 16.138 15.789 16.2189 15.8949 16.2964C15.9032 16.3025 15.9099 16.3105 15.9144 16.3198C15.9188 16.3292 15.9209 16.3395 15.9204 16.3498C15.9199 16.3601 15.9168 16.3702 15.9115 16.379C15.9062 16.3878 15.8988 16.3953 15.8899 16.4005C15.3915 16.6872 14.8732 16.9296 14.329 17.1313C14.3207 17.1343 14.3131 17.1391 14.3067 17.1453C14.3003 17.1515 14.2954 17.1591 14.2922 17.1674C14.2889 17.1757 14.2875 17.1846 14.288 17.1933C14.2884 17.2022 14.2908 17.211 14.2949 17.2189C14.5949 17.7914 14.9382 18.3364 15.3157 18.8539C15.3236 18.8645 15.3345 18.8724 15.347 18.8766C15.3595 18.8808 15.3731 18.8809 15.3857 18.8771C17.181 18.3368 18.872 17.497 20.3874 16.393C20.3948 16.3878 20.401 16.3812 20.4056 16.3734C20.4102 16.3657 20.413 16.3569 20.414 16.3479C20.8307 12.1031 19.7157 8.41468 17.4565 5.14636C17.451 5.13574 17.4418 5.12746 17.4307 5.12303ZM7.18323 14.1114C6.19823 14.1114 5.38573 13.2206 5.38573 12.1281C5.38573 11.0347 6.1824 10.1447 7.18323 10.1447C8.19156 10.1447 8.99656 11.0422 8.98072 12.1281C8.98072 13.2214 8.18406 14.1114 7.18323 14.1114ZM13.829 14.1114C12.8432 14.1114 12.0315 13.2206 12.0315 12.1281C12.0315 11.0347 12.8274 10.1447 13.829 10.1447C14.8374 10.1447 15.6424 11.0422 15.6265 12.1281C15.6265 13.2214 14.8382 14.1114 13.829 14.1114Z"
          fill="#181C1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_4336_69911">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.879883)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TwitterIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4336_69914)">
        <path
          d="M19.2167 5.87955C18.575 6.17122 17.8833 6.36289 17.1667 6.45455C17.9 6.01289 18.4667 5.31289 18.7333 4.47122C18.0417 4.88789 17.275 5.17956 16.4667 5.34622C15.8083 4.62956 14.8833 4.21289 13.8333 4.21289C11.875 4.21289 10.275 5.81289 10.275 7.78789C10.275 8.07122 10.3083 8.34622 10.3667 8.60455C7.4 8.45455 4.75833 7.02955 3 4.87122C2.69166 5.39622 2.51666 6.01289 2.51666 6.66289C2.51666 7.90455 3.14166 9.00455 4.10833 9.62955C3.51666 9.62955 2.96666 9.46289 2.48333 9.21289V9.23789C2.48333 10.9712 3.71666 12.4212 5.35 12.7462C4.8256 12.8897 4.27508 12.9097 3.74166 12.8045C3.968 13.5149 4.41128 14.1365 5.00918 14.582C5.60708 15.0274 6.32954 15.2743 7.075 15.2879C5.81136 16.2882 4.24499 16.829 2.63333 16.8212C2.35 16.8212 2.06666 16.8045 1.78333 16.7712C3.36666 17.7879 5.25 18.3795 7.26666 18.3795C13.8333 18.3795 17.4417 12.9295 17.4417 8.20455C17.4417 8.04622 17.4417 7.89622 17.4333 7.73789C18.1333 7.23789 18.7333 6.60455 19.2167 5.87955Z"
          fill="#181C1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_4336_69914">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.879883)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedInIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4336_69917)">
        <path
          d="M16.3333 3.37988C16.7754 3.37988 17.1993 3.55547 17.5118 3.86804C17.8244 4.1806 18 4.60452 18 5.04655V16.7132C18 17.1553 17.8244 17.5792 17.5118 17.8917C17.1993 18.2043 16.7754 18.3799 16.3333 18.3799H4.66667C4.22464 18.3799 3.80072 18.2043 3.48816 17.8917C3.17559 17.5792 3 17.1553 3 16.7132V5.04655C3 4.60452 3.17559 4.1806 3.48816 3.86804C3.80072 3.55547 4.22464 3.37988 4.66667 3.37988H16.3333ZM15.9167 16.2966V11.8799C15.9167 11.1594 15.6304 10.4684 15.121 9.95891C14.6115 9.44943 13.9205 9.16321 13.2 9.16321C12.4917 9.16321 11.6667 9.59655 11.2667 10.2466V9.32155H8.94167V16.2966H11.2667V12.1882C11.2667 11.5466 11.7833 11.0216 12.425 11.0216C12.7344 11.0216 13.0312 11.1445 13.25 11.3633C13.4688 11.5821 13.5917 11.8788 13.5917 12.1882V16.2966H15.9167ZM6.23333 8.01321C6.60464 8.01321 6.96073 7.86571 7.22328 7.60316C7.48583 7.34061 7.63333 6.98452 7.63333 6.61321C7.63333 5.83821 7.00833 5.20488 6.23333 5.20488C5.85982 5.20488 5.5016 5.35326 5.23749 5.61737C4.97338 5.88148 4.825 6.2397 4.825 6.61321C4.825 7.38821 5.45833 8.01321 6.23333 8.01321ZM7.39167 16.2966V9.32155H5.08333V16.2966H7.39167Z"
          fill="#181C1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_4336_69917">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.879883)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
